import React from "react";
import Hero from "../Hero/Hero";
import HeroAlternative from "../HeroAlternative/Hero";
import Clients from "../Clients/Clients";
import TwoColumn from "../Common/TwoColumn/TwoColumn";
import ImageGrid from "../Common/ImageGrid/ImageGrid";
import ServicesAccordion from "../Services/Services";
import ServicesCardsSection from "../ServicesSection/ServicesSection";
import AlternatingImageText from "../AlternatingImageText/AlternatingImageText";
import Gallery from "../Gallery/Gallery";
import FAQAccordion from "../FAQAccordion/FAQAccordion";
import Team from "../Team/Team";
import Contact from "../Contact/Contact";
import BookSpaceForm from "../BookSpaceForm/BookSpaceForm";
import LegalSections from "../LegalSections/LegalSections";

const SECTION_MAP = {
  hero: Hero,
  heroAlternative: HeroAlternative,
  clients: Clients,
  twoColumn: TwoColumn,
  imageGrid: ImageGrid,
  servicesAccordion: ServicesAccordion,
  servicesCardsSection: ServicesCardsSection,
  alternatingImageText: AlternatingImageText,
  gallery: Gallery,
  faqAccordion: FAQAccordion,
  team: Team,
  contactSection: Contact,
  bookSpaceForm: BookSpaceForm,
  legalSections: LegalSections,
};

export default function PageBuilder({ sections = [], documentId }) {
  return (
    <>
      {sections.map((section, i) => {
        const Component = SECTION_MAP[section._type];
        if (!Component) {
          console.warn(`No component registered for section type: ${section._type}`);
          return null;
        }
        return (
          <Component
            key={section._key || i}
            data={section}
            documentId={documentId}
            sectionKey={section._key}
          />
        );
      })}
    </>
  );
}
